export default {
    untersuchungen: state => {
        return state.untersuchungen
    }
}